<div style="width:550px">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="form-group col-lg-6">
        <label>Planned Assessment Date</label>
        <div class="col-lg-11" style="position:relative">
          <input [matDatepicker]="plannedAssessmentDatePicker"
            [(ngModel)]="data.PlannedAssessmentDate"
            class="form-control"
            formControlName="plannedAssessmentDateForm"
            (dateChange)="getDateUTCChange($event, 'plannedAssessmentDateForm')"
            readonly />
            @if (form.get('plannedAssessmentDateForm')?.value) {
              <button mat-icon-button matSuffix (click)="clearDate('plannedAssessmentDateForm')" class="clear-icon">
                <mat-icon>clear</mat-icon>
              </button>
            }
          </div>
          <div class="col-lg-1" style="padding-left:0">
            <mat-datepicker-toggle matSuffix [for]="plannedAssessmentDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #plannedAssessmentDatePicker></mat-datepicker>
          </div>
        </div>
        <div class="form-group col-lg-6">
          <label>Actual Assessment Date</label>
          <div class="col-lg-11" style="position:relative">
            <input [matDatepicker]="actualAssessmentDatePicker"
              [(ngModel)]="data.ActualAssessmentDate"
              class="form-control"
              formControlName="actualAssessmentDateForm"
              (dateChange)="getDateUTCChange($event, 'actualAssessmentDateForm')"
              readonly />
              @if (form.get('actualAssessmentDateForm')?.value) {
                <button mat-icon-button matSuffix (click)="clearDate('actualAssessmentDateForm')" class="clear-icon">
                  <mat-icon>clear</mat-icon>
                </button>
              }
            </div>
            <div class="col-lg-1" style="padding-left:0">
              <mat-datepicker-toggle matSuffix [for]="actualAssessmentDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #actualAssessmentDatePicker></mat-datepicker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label>Planned Validation Call Date</label>
            <div class="col-lg-11" style="position:relative">
              <input [matDatepicker]="plannedValidationCallDatePicker"
                class="form-control"
                [(ngModel)]="data.PlannedValidationCallDate"
                formControlName="plannedValidationCallDateForm"
                (dateChange)="getDateUTCChange($event, 'plannedValidationCallDateForm')"
                readonly />
                @if (form.get('plannedValidationCallDateForm')?.value) {
                  <button mat-icon-button matSuffix (click)="clearDate('plannedValidationCallDateForm')" class="clear-icon">
                    <mat-icon>clear</mat-icon>
                  </button>
                }
              </div>
              <div class="col-lg-1" style="padding-left:0">
                <mat-datepicker-toggle matSuffix [for]="plannedValidationCallDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #plannedValidationCallDatePicker></mat-datepicker>
              </div>
            </div>
            <div class="form-group col-lg-6">
              <label>Actual Validation Call Date</label>
              <div class="col-lg-11" style="position:relative">
                <input [matDatepicker]="actualValidationCallDatePicker"
                  class="form-control"
                  [(ngModel)]="data.ActualValidationCallDate"
                  formControlName="actualValidationCallDateForm"
                  (dateChange)="getDateUTCChange($event, 'actualValidationCallDateForm')"
                  readonly />
                  @if (form.get('actualValidationCallDateForm')?.value) {
                    <button mat-icon-button matSuffix (click)="clearDate('actualValidationCallDateForm')" class="clear-icon">
                      <mat-icon>clear</mat-icon>
                    </button>
                  }
                </div>
                <div class="col-lg-1" style="padding-left:0">
                  <mat-datepicker-toggle matSuffix [for]="actualValidationCallDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #actualValidationCallDatePicker></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <label>Actual Check-in Call 1 Date</label>
                <div class="col-lg-11" style="position:relative">
                  <input [matDatepicker]="actualCheckInCall_1_DatePicker"
                    class="form-control"
                    [(ngModel)]="data.ActualCheckInCall_1_Date"
                    formControlName="actualCheckInCall_1_DateForm"
                    (dateChange)="getDateUTCChange($event, 'actualCheckInCall_1_DateForm')"
                    readonly />
                    @if (form.get('actualCheckInCall_1_DateForm')?.value) {
                      <button mat-icon-button matSuffix (click)="clearDate('actualCheckInCall_1_DateForm')" class="clear-icon">
                        <mat-icon>clear</mat-icon>
                      </button>
                    }
                  </div>
                  <div class="col-lg-1" style="padding-left:0">
                    <mat-datepicker-toggle matSuffix [for]="actualCheckInCall_1_DatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #actualCheckInCall_1_DatePicker></mat-datepicker>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Actual Check-in Call 2 Date</label>
                  <div class="col-lg-11" style="position:relative">
                    <input [matDatepicker]="actualCheckInCall_2_DatePicker"
                      class="form-control"
                      [(ngModel)]="data.ActualCheckInCall_2_Date"
                      formControlName="actualCheckInCall_2_DateForm"
                      (dateChange)="getDateUTCChange($event, 'actualCheckInCall_2_DateForm')"
                      readonly />
                      @if (form.get('actualCheckInCall_2_DateForm')?.value) {
                        <button mat-icon-button matSuffix (click)="clearDate('actualCheckInCall_2_DateForm')" class="clear-icon">
                          <mat-icon>clear</mat-icon>
                        </button>
                      }
                    </div>
                    <div class="col-lg-1" style="padding-left:0">
                      <mat-datepicker-toggle matSuffix [for]="actualCheckInCall_2_DatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #actualCheckInCall_2_DatePicker></mat-datepicker>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-lg-6">
                    <label>Actual Check-in Call 3 Date</label>
                    <div class="col-lg-11" style="position:relative">
                      <input [matDatepicker]="actualCheckInCall_3_DatePicker"
                        class="form-control"
                        [(ngModel)]="data.ActualCheckInCall_3_Date"
                        formControlName="actualCheckInCall_3_DateForm"
                        (dateChange)="getDateUTCChange($event, 'actualCheckInCall_3_DateForm')"
                        readonly />
                        @if (form.get('actualCheckInCall_3_DateForm')?.value) {
                          <button mat-icon-button matSuffix (click)="clearDate('actualCheckInCall_3_DateForm')" class="clear-icon">
                            <mat-icon>clear</mat-icon>
                          </button>
                        }
                      </div>
                      <div class="col-lg-1" style="padding-left:0">
                        <mat-datepicker-toggle matSuffix [for]="actualCheckInCall_3_DatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #actualCheckInCall_3_DatePicker></mat-datepicker>
                      </div>
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Actual Check-in Call 4 Date</label>
                      <div class="col-lg-11" style="position:relative">
                        <input [matDatepicker]="actualCheckInCall_4_DatePicker"
                          class="form-control"
                          [(ngModel)]="data.ActualCheckInCall_4_Date"
                          formControlName="actualCheckInCall_4_DateForm"
                          (dateChange)="getDateUTCChange($event, 'actualCheckInCall_4_DateForm')"
                          readonly />
                          @if (form.get('actualCheckInCall_4_DateForm')?.value) {
                            <button mat-icon-button matSuffix (click)="clearDate('actualCheckInCall_4_DateForm')" class="clear-icon">
                              <mat-icon>clear</mat-icon>
                            </button>
                          }
                        </div>
                        <div class="col-lg-1" style="padding-left:0">
                          <mat-datepicker-toggle matSuffix [for]="actualCheckInCall_4_DatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #actualCheckInCall_4_DatePicker></mat-datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-lg-6">
                        <label for="actualFinalCheckInCall_Date">Actual Final Check-in Call Date</label>
                        <div class="col-lg-11" style="position:relative">
                          <input id="actualFinalCheckInCall_Date"
                            [matDatepicker]="actualFinalCheckInCall_DatePicker"
                            class="form-control"
                            [(ngModel)]="data.ActualFinalCheckInCall_Date"
                            formControlName="actualFinalCheckInCall_DateForm"
                            (dateChange)="getDateUTCChange($event, 'actualFinalCheckInCall_DateForm')"
                            readonly />
                            @if (form.get('actualFinalCheckInCall_DateForm')?.value) {
                              <button mat-icon-button matSuffix (click)="clearDate('actualFinalCheckInCall_DateForm')" class="clear-icon">
                                <mat-icon>clear</mat-icon>
                              </button>
                            }
                          </div>
                          <div class="col-lg-1" style="padding-left:0">
                            <mat-datepicker-toggle matSuffix [for]="actualFinalCheckInCall_DatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #actualFinalCheckInCall_DatePicker></mat-datepicker>
                          </div>
                        </div>
                      </div>
                    <div class="row">
                      <div class="panel-body">
                        <button (click)="backButtonHandler($event)" mat-raised-button class="btn  button-color-fix_red ">
                          <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
                          Back
                        </button>
                        <button mat-raised-button type="submit" class="btn button-color-fix pull-right">
                          Save
                          <mat-icon class="icon-color-fix">save</mat-icon>
                        </button>

                      </div>
                    </div>
                  </form>
                </div>